module.exports = __webpack_public_path__ + "static/img/Sainz.24f5593.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Sainz.jpg
// module id = 3LlP
// module chunks = 1